module.exports = __webpack_public_path__ + "img/image20.e7d10180.jpg";